<template>
  <div class="wlx-site-manager-wrapper">
    <header class="site-manager-head-con">
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-input v-model="title" placeholder="请输标题" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- 查看弹框 -->
    <el-dialog
      title="查看信息"
      v-if="viewNoticeVisible"
      :visible.sync="viewNoticeVisible"
      :before-close="cancel"
      :append-to-body="true"
      width="50%"
      :close-on-click-modal="false"
    >
      <div>
        <el-form ref="ruleForm" label-width="80px" disabled>
          <el-form-item label="活动标题" prop="title">
            <el-input v-model="title"></el-input>
          </el-form-item>
          <el-form-item label="活动内容">
            <Editor v-model="content" placeholder="请输入内容"/>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancel">确 定</el-button>
      </span>
    </el-dialog>
        <!--审核弹窗-->
        <el-dialog
          title="提示"
          :visible.sync="dialogVisibleAudit"
          width="30%"
          :append-to-body="true"
          :before-close="cancel"
          :close-on-click-modal="false"
        >
          <el-radio-group v-model="IsAudit">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">不通过</el-radio>
          </el-radio-group>
          <el-input type="textarea" class="textarea-class-input" v-if="IsAudit == 2" v-model="reason" placeholder="请输入不通过原因"></el-input>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibleAudit = false">取 消</el-button>
            <el-button type="primary" @click="shenhe">确 定</el-button>
          </span>
        </el-dialog>    

    <el-table
      ref="multipleeeeTable"
      :data="list"
      tooltip-effect="dark"
      empty-text=" "
      style="width: 100%;"
      @selection-change="handleSelectionChange"
    >
      <el-table-column prop="id" type="selection" width="55"></el-table-column>
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column prop="title" label="活动标题" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="内容" :show-overflow-tooltip="true" width="240">
        <template slot-scope="scope">
          <p v-html="scope.row.contentText"></p>
        </template>
      </el-table-column>
      <el-table-column prop="dateCreated" label="创建时间" width="160"></el-table-column>
      <el-table-column prop="associationName" label="创建人" width="80"></el-table-column>
      <el-table-column prop="siteName" label="所属站点"></el-table-column>
      <el-table-column prop="siteName" label="审核状态" width="80">
        <template slot-scope="scope">
          <span style="color: #05C94F" v-if="scope.row.IsAudit==1">审核通过</span>
          <span style="color: #E53939" v-if="scope.row.IsAudit==2">审核不通过</span>
          <span style="color: #2D82FF" v-if="scope.row.IsAudit==0">待审核</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="orderNumber" label="排序"></el-table-column> -->
      <el-table-column prop="pulishTime" label="开始时间" width="160"></el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="audit(scope.row.id)"
            type="primary"
            title="审核"
          >审核</el-button>
          <el-button size="mini" type="primary" @click="viewSchoolNews(scope.row)" title="查看">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="u-page-con">
       <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="onPageChangeHandler"
      :current-page="pageIndex"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      v-show="total>0"
    ></el-pagination>
    </div>
  </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
  data() {
    return {
      list: [],
      SiteList: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      addNewNoticeVisible: false,
      editNoticeVisible: false,
      viewNoticeVisible: false,
      dialogVisibleAudit:false,
      /* -----------添加/修改弹框参数------------ */
      sTitle: "",
      title: "",
      content: "",
      avatorUrl: "",
      newsType: 1,
      orderNumber: 0,
      pulishTime: "",
      /* --------------------------------------- */
      id: "",
      ids: [],
      siteId: "",
      siteName: "",
      // noDataShow: false,
      value: "",
      attestationId: "",
      IsAudit:1,
      reason:'',
    };
  },
  components: {
    imageUpload
  },
  created() {
    this.school = this.$store.state.auth.userName;
    this.getAttestationList();
  },
  methods: {
    getAttestationList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationAttestation/getAttestationList", {
          page: page,
          pageSize: this.pageSize,
          title: that.title,
          value: 3
        })
        .then(rst => {
          if (rst.code == 1) {
            this.list = rst.list;
            this.total = rst.pagination.totalCount;
            this.pageSize = rst.pagination.pageSize;
            this.pageIndex = rst.pagination.pageIndex;
            this.cancel();
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    // //审核信息
    // audit(id) {
    //   var that = this;
    //   this.$http
    //     .post("/api/XOrg/AssociationAttestation/auditStuActivity", {
    //       attestationId: id
    //     })
    //     .then(rst => {
    //       if (rst.code == 1) {
    //         that.$message.success(rst.msg);
    //         that.getAttestationList();
    //       } else {
    //         that.$message.warning(rst.msg);
    //       }
    //     });
    // },
    //审核信息
    audit(id){
      this.attestationId = id;
      this.dialogVisibleAudit = true
    },
    //审核
    shenhe(){
      var that = this;
      this.$http.post(
        '/api/XOrg/AssociationAttestation/auditStuActivity',
        {
          attestationId: that.attestationId,
          type: that.IsAudit,
          reason: that.reason
        }
      )
      .then(rst =>{
        if (rst.code == 1){
          that.$message.success(rst.msg);
          that.dialogVisibleAudit = false;
          that.getAttestationList();
        }else if(rst.code == -2){
          that.$message.warning(rst.msg);
          that.dialogVisibleAudit = false;
          that.getAttestationList();
        }else{
          that.dialogVisibleAudit = false;
          that.$message.warning(rst.msg);
        }
      });
    },
    onPageChangeHandler(page) {
      this.getAttestationList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getAttestationList();
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach(element => {
        this.ids.push(element.Id);
      });
    },
    cancel() {
      (this.addNewNoticeVisible = false),
      (this.editNoticeVisible = false),
      (this.viewNoticeVisible = false),
      (this.dialogVisibleAudit = false),
      (this.siteId = ""),
      (this.title = ""),
      (this.content = ""),
      (this.avatorUrl = "");
      (this.reason ='');
      this.newsType = 1;
      this.pulishTime = "";
    },
    viewSchoolNews(row) {
      this.title = row.title;
      this.content = row.content;
      this.viewNoticeVisible = true;
    },
    search() {
      this.getAttestationList(1);
    }
  }
};
</script>
